import { HttpInterceptorFn } from '@angular/common/http';
import { HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TenantService } from '@foxera/feature/tenant/services/tenant.service';
import { environment } from '@foxera/environments/enviroment';

export const TenantIdInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
) => {
  const tenantService = inject(TenantService);
  
  // Try to get tenant from signal first (in-memory, faster), then fallback to storage
  let selectedTenant = tenantService.getSelectedTenant();
  if (!selectedTenant) {
    selectedTenant = tenantService.getSelectedTenantFromStorage();
  }

  // Skip tenant ID header for public API calls
  const isPublicApiCall = req.url.includes(environment.public_api_business_base_url);
  if (isPublicApiCall) {
    return next(req);
  }

  // Add tenant ID header for all other API calls if available
  if (selectedTenant?.id) {
    const modifiedReq = req.clone({
      setHeaders: {
        'Current-Tenant-ID': selectedTenant.id,
      },
    });
    return next(modifiedReq);
  }

  // If no tenant selected, proceed without the header
  return next(req);
};
